import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Position component is a wrapper component that gives the containing component css positioning abilities.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/Box"
      }}>{`Box`}</a>{` instead.`}</p>
    <p><strong parentName="p">{`Before`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<>
  <Position position="absolute">...</Position>
  <Absolute>...</Absolute>
  <Relative>...</Relative>
  <Fixed>...</Fixed>
  <Sticky>...</Sticky>
</>
`}</code></pre>
    <p><strong parentName="p">{`After`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<>
  <Box position="absolute">...</Box>
  <Box position="absolute">...</Box>
  <Box position="relative">...</Box>
  <Box position="fixed">...</Box>
  <Box position="sticky">...</Box>
</>
`}</code></pre>
    <h2>{`Default examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated live",
        "deprecated": true,
        "live": true
      }}>{`<Box p={2} mb={200}>
  <Heading mb={2}>Relative + Absolute</Heading>
  <Relative size={128} mx={128} my={6}>
    <Box borderWidth="1px" borderStyle="solid" borderColor="border.default" borderRadius={2} size="100%">
      <Absolute left="100%" top={0} color="fg.onEmphasis" bg="success.emphasis" p={1}>
        rt
      </Absolute>
      <Absolute right="100%" top={0} color="fg.onEmphasis" bg="success.emphasis" p={1}>
        lt
      </Absolute>
      <Absolute left="100%" bottom={0} color="fg.onEmphasis" bg="success.emphasis" p={1}>
        rb
      </Absolute>
      <Absolute right="100%" bottom={0} color="fg.onEmphasis" bg="success.emphasis" p={1}>
        lb
      </Absolute>
      <Absolute left={0} top="100%" color="fg.onEmphasis" bg="success.emphasis" p={1}>
        bl
      </Absolute>
      <Absolute right={0} top="100%" color="fg.onEmphasis" bg="success.emphasis" p={1}>
        br
      </Absolute>
      <Absolute left={0} bottom="100%" color="fg.onEmphasis" bg="success.emphasis" p={1}>
        tl
      </Absolute>
      <Absolute right={0} bottom="100%" color="fg.onEmphasis" bg="success.emphasis" p={1}>
        tr
      </Absolute>
    </Box>
  </Relative>

  <Heading my={2}>Sticky</Heading>

  <Box borderWidth="1px" borderStyle="solid" borderColor="success.emphasis" borderRadius={2} border={1} height={500}>
    <Sticky top={0} bg="success.subtle" p={6}>
      I'm sticky!
    </Sticky>
  </Box>

  <Heading my={2}>Fixed</Heading>
  <p>(see the bottom right of the screen)</p>

  <Fixed bottom={0} right={0} color="fg.onEmphasis" bg="danger.emphasis" p={2}>
    I'm fixed to the bottom right.
  </Fixed>
</Box>
`}</code></pre>
    <h2>{`System props`}</h2>
    <p>{`Position components get `}<inlineCode parentName="p">{`POSITION`}</inlineCode>{`, `}<inlineCode parentName="p">{`LAYOUT`}</inlineCode>{`, `}<inlineCode parentName="p">{`FLEX`}</inlineCode>{`, and `}<inlineCode parentName="p">{`COMMON`}</inlineCode>{` system props. Read our `}<a parentName="p" {...{
        "href": "/system-props"
      }}>{`System Props`}</a>{` doc page for a full list of available props.`}</p>
    <h2>{`Component props`}</h2>
    <p>{`Position does not get any additional props other than the system props mentioned above.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      